import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TranslationContext } from 'giro-react-toolkit/source/Translation';
import FormGroup from "../formGroup";
/**
 * Component used to select a day.
 */
class DurationPicker extends Component {
   constructor(props) {
      super(props);
      this.selectRef = React.createRef();

      this.handleChange = this.handleChange.bind(this);
   }

   /**
    * Put the focus on the dayPicker input
    */
   focus() {
      this.selectRef.current.focus();
   }

   /**
    * Handle the day picker change event
    * @param e - The event object
    */
   handleChange(e) {
      const value = Number(e.target.value);

      if (this.props.onSelectedDur)
         this.props.onSelectedDur(value);
   }

   /**
    * renders the DayPicker component
    */
   render() {
      const durList = reachMap.durationOptions.values;

      return (
         <FormGroup
            className={this.props.className}
            iconName="timer"
            labelId="dur-picker-label"
            resourceKey="ReachMapRes.DurationLabelText">
            <select
               value={this.props.selectedDur}
               onChange={this.handleChange}
               ref={this.selectRef}>
               {
                  durList.map(dur => {
                     return (
                        <option key={dur} value={dur}>
                           {dur} {this.context.localizeValue('ReachMapRes.DurationUnit')}
                        </option>
                     );
                  })
               }
            </select>
         </FormGroup>
      );
   }
}

DurationPicker.propTypes = {
   /**
    * class to apply to the component
    */
   className: PropTypes.string,
   /**
    * A callback called when a day is selected
    */
   onSelectedDur: PropTypes.func,
   /**
    * Current value of the picklist
    */
   selectedDur: PropTypes.number
}

DurationPicker.contextType = TranslationContext;

export default DurationPicker;
